import * as BookmarkTypes from 'common/types/reports/bookmark';

import {isBehaviorShowClause, isFormulaShowClause} from '../models/utils';

function isEntityIdReferencedInShowClause(
  clause: BookmarkTypes.BehaviorShowClause,
  {metricIds, behaviorIds}: {metricIds?: number[]; behaviorIds?: number[]},
) {
  return (
    (clause.id && metricIds?.includes(clause.id)) || (clause.behavior?.id && behaviorIds?.includes(clause.behavior.id))
  );
}

/**
 * Determines whether any of the entities specified by `metricIds` or `behaviorIds`
 * are referenced within the `show` clauses of the provided bookmark parameters.
 *
 * Iterates through each clause in `params.sections.show` and checks if:
 * - The clause is a behavior show clause and references any of the specified entity IDs.
 * - The clause is a formula show clause and any of its referenced metrics reference the specified entity IDs.
 *
 * @param params - The bookmark parameters containing sections and show clauses.
 * @param metricIds - Optional array of metric entity IDs to check for references.
 * @param behaviorIds - Optional array of behavior entity IDs to check for references.
 * @returns `true` if any of the specified entity IDs are referenced in the show clauses; otherwise, `false`.
 */
export function isBookmarkReferencingEntitiesIds({
  params,
  metricIds,
  behaviorIds,
}: {
  params: BookmarkTypes.InsightsBookmarkParams;
  metricIds?: number[];
  behaviorIds?: number[];
}) {
  for (const clause of params.sections.show) {
    if (
      (isBehaviorShowClause(clause) && isEntityIdReferencedInShowClause(clause, {metricIds, behaviorIds})) ||
      /// check metrics inside a formula
      (isFormulaShowClause(clause) &&
        clause.referencedMetrics?.some((metric) => isEntityIdReferencedInShowClause(metric, {metricIds, behaviorIds})))
    ) {
      return true;
    }
  }

  return false;
}
